import {CSSProperties, useCallback} from "react";
import {message} from "antd";
import {PublicEventDTO, PublicTableDTO} from "../home/types";

export const useClipboard = () => {

    const style: CSSProperties = {
        marginTop: '100px'
    };

    const copyToClipboard = useCallback((text: string) => {
        navigator.clipboard.writeText(text)
        .then(() => {
            message.success({
                key: text,
                content: 'Copied to clipboard!',
                style
            });
        }).catch(() => {
            message.error({
                key: text,
                content: 'Failed to copy clipboard!',
                style
            });
        });
    }, [message]);

    return {copyToClipboard}

};

export const useEventShare = (event: PublicEventDTO, table: PublicTableDTO) => {
    const sharePath = window.location.origin + `/reserve/${event.tag}/${table.tag}`
    const { copyToClipboard } = useClipboard();
    const copyTableSharePath = useCallback(() => {
        copyToClipboard(sharePath);
    }, [sharePath,copyToClipboard]);

    return {copyTableSharePath}
}